import { render, staticRenderFns } from "./NLTransactions2.vue?vue&type=template&id=6bc85707&"
import script from "./NLTransactions2.vue?vue&type=script&lang=js&"
export * from "./NLTransactions2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports